<script setup lang="ts">
import LoadingSpinner from '@/components/common/ui/LoadingSpinner.vue'
import { translationFunctionDefault } from '@/utilities/translations'

interface ManagementSuggestionLoadingProps {
  organizationName: string
}

defineProps<ManagementSuggestionLoadingProps>()

const tfDefault = translationFunctionDefault()

const PLACEHOLDER_ROWS = 2
</script>

<template>
  <div class="flex flex-col gap-3 py-2" role="status">
    <div class="flex items-center gap-3 text-sm text-black-700">
      <div class="shrink-0">
        <LoadingSpinner size="1.25rem" />
      </div>
      <span>
        {{
          organizationName
            ? tfDefault('managementSuggestions.searchingFor', { name: organizationName })
            : tfDefault('managementSuggestions.searching')
        }}
      </span>
    </div>
    <!-- Placeholder rows in the shape of the suggestions that are still loading -->
    <div
      v-for="row in PLACEHOLDER_ROWS"
      :key="row"
      aria-hidden="true"
      class="flex items-start gap-4 border-b border-dotted border-black-400 py-3 last:border-none"
    >
      <div class="size-12 shrink-0 animate-pulse rounded-full bg-black-200"></div>
      <div class="flex flex-1 flex-col gap-2 pt-1">
        <div class="h-4 w-2/5 animate-pulse rounded-md bg-black-200"></div>
        <div class="h-3 w-1/3 animate-pulse rounded-md bg-black-200"></div>
        <div class="h-3 w-1/2 animate-pulse rounded-md bg-black-200"></div>
      </div>
    </div>
  </div>
</template>
